import {handleActions} from 'redux-actions';
import {DeviseUser} from '../constants/models';
const  DeviseUserReducers = handleActions({
    SET_USER_TOKEN: (state, {payload}) => (
        state.merge({
            token: payload
        })
    ),
}, DeviseUser);

export default DeviseUserReducers;


// WEBPACK FOOTER //
// ./src/dashboards_redux/reducers/DeviseUserReducers.jsx